<template>
  <div class="panel-body container mb-4">
    <div v-if="loading" class="loading fullheight" id="loader">
      <div class="lds-dual-ring"></div>
    </div>
    <div class="mt-3 pt-3 ">
      <p class="label"> Lotto selezionato:</p> 
      <p class="lotto_materie_prime">{{model.Lotto_materie_prime}}</p>
    </div>
    <div class="mt-3 px-3 pb-3">
    <vue-form-generator :schema="fetch" :model="model" :options="formOptions"></vue-form-generator>
    </div>
  <div role="tablist" v-if="(fetched && !sent)">
    <div v-for="d in this.deliveries" v-bind:key="d.id">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle="'accordion-' + d.id" variant="info">Delivery {{d.carriername}}</b-button>
      </b-card-header>
      <b-collapse :id="'accordion-' + d.id" :visible="true" accordion="my-accordion" role="tabpanel" ref="id">
        <b-card-body>
          <b-tabs content-class="mt-3" fill>
            <b-tab title="Prima Analisi" active><vue-form-generator :model="model" :schema="schema_step_1" :options="formOptions"></vue-form-generator></b-tab>
            <b-tab title="Seconda Analisi" :disabled="second == true"><vue-form-generator :schema="schema_step_2" :model="model" :options="formOptions"></vue-form-generator>
              <b-button type="submit" @click="saveForm(d.id)" href="#">Invia</b-button></b-tab>
          </b-tabs>
              <p v-if="msg_analysis_record">{{msg_analysis_record}}</p>
        </b-card-body>
      </b-collapse>
    </b-card>
    </div>
    <div v-if="(analisi_temp.length>0 && !sent)"> 
      <b-button type="submit" @click="sendData()" href="#">Registra le analisi</b-button>
      </div>
      <p>{{this.msg_conferma}}</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
//import ModuleLibrary from 'vfg-field-object';
// Install this library
//this.vm.use(ModuleLibrary);
//import analisiform from '@/components/analisiform'
export default {
  name: 'analisi',
  components: {
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_ROOT_API,
      config: {headers: { Authorization: 'bearer ' + localStorage.getItem('access_token') }},
      loading: false,
      second: true,
      counter: 0,
      fetched: false,
      sent: false,
      analisi_temp: [],
      rawmplist: [],
      deliveries: [],
      msg_conferma: '',
      msg_analysis_record: '',
      model: {
        bacterial: null,
        fat: null,
        protein: null,
        ph: null,
        sourness: null,
        stranger_milk: false,
        antibiotics: false,
        mastitis: false,
        temperature: null
      },
      temp: {},
      fetch: {
        fields: [
        {
            type: 'select',
            inputType: 'number',
            label: 'Lotto materie prime',
            model: 'Lotto_materie_prime',
            values: [],
            placeholder: 'Seleziona codice lotto',
            featured: false,
            objectLimit:5,
            selectOptions: {
              value: 'name',
              name: "name",
              hideNoneSelectedText: true
            },
            required: true,
            disabled: false
          },
          {
            type: 'submit',
            buttonText: 'Conferma',
            validateBeforeSubmit: true,
            onSubmit: this.fetchData,
            disabled: false
          }
        ]
      },
      schema_step_1: {
        fields: [
          {
            type: 'input',
            inputType: 'number',
            label: 'Temperature',
            model: 'temperature',
            placeholder: 'inserisci temperatura',
            required: true
          },
          {
            type: 'input',
            inputType: 'number',
            label: 'pH',
            model: 'ph',
            min: 5,
            max: 10,
            placeholder: '6.6 ÷ 6.8',
            required: true
          },
          {
            type: 'input',
            inputType: 'number',
            label: 'Carica batterica',
            model: 'bacterial',
            placeholder: '< 1.5 ufc/ml',
          },
          {
            type: 'input',
            inputType: 'number',
            label: 'Acidità (°SH/50ml)',
            model: 'sourness',
            min: 2,
            max: 6,
            placeholder: '3 ÷ 4.5',
            required: true
          },
          {
            type: 'submit',
            buttonText: 'Validare',
            validateBeforeSubmit: true,
            onSubmit: this.nextStep
          }
        ]
      },
      schema_step_2: {
        fields: [
          {
            type: 'input',
            inputType: 'number',
            label: 'Grasso',
            model: 'fat',
            placeholder: '≥8%',
            required: true
          },
          {
            type: 'input',
            inputType: 'number',
            label: 'Proteine',
            model: 'protein',
            placeholder: '≥4.6%',
            required: true
          },
          {
            type: 'checkbox',
            label: 'Latte Estraneo',
            model: 'stranger_milk',
            default: false,
          },
          {
            type: 'checkbox',
            label: 'Mastite',
            model: 'mastitis',
            default: false
          },
          {
            type: 'checkbox',
            label: 'Antibiotici',
            model: 'antibiotics',
            default: false
          }
        ]
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: false,
        validateAsync: false
      }
    }
  },
  mounted () {
    this.getrawmplist()
  },
  methods: {
    clicker: function () {
      this.counter = this.counter + 1
    },
    saveForm: function (id) {
      if (!this.model.sourness || !this.model.temperature || !this.model.ph || !this.model.fat || !this.model.protein) {
        this.msg_analysis_record = 'Compila tutti i campi e riprova'
      }
      else {
      try {
      this.msg_analysis_record = ''
      this.loading = true
      var object = {
        "id": id,
        "bacterial": this.model.bacterial,
        "fat": this.model.fat,
        "protein": this.model.protein,
        "ph": this.model.ph,
        "sourness": this.model.sourness,
        "stranger_milk": this.model.stranger_milk,
        "antibiotics": this.model.antibiotics,
        "mastitis": this.model.mastitis,
        "temperature": this.model.temperature
        }
      this.analisi_temp.push(object)
      // eslint-disable-next-line
      //  console.log("analisi_temp",this.analisi_temp)
      // array dove salvo i dati analisi_temp
      //da aggiungere array di oggetti che salva ogni scheda 
      this.$store.dispatch('update_analisi', object)
      var lotto = this.model.Lotto_materie_prime
      this.model = {}
      this.model.Lotto_materie_prime = lotto
      this.second = true
      var refresh = this.$refs.id[+ this.counter].$el.id
      this.$root.$emit('bv::toggle::collapse', refresh)
      this.clicker()
      var next = this.$refs.id[+ this.counter].$el.id
      this.$root.$emit('bv::toggle::collapse', next)
      this.loading = false
      }
    catch (e) {
      // console.log("Inserimento completato")
      this.loading = false
    }
      }
    },
    nextStep: function () {
      if (!this.model.sourness || !this.model.temperature || !this.model.ph) {
        this.msg_analysis_record = 'Compila tutti i campi e riprova'
      }
      else {
      this.msg_analysis_record = ''
      this.second = false
      }
    },
    fetchData: function () {
    this.loading = true
    this.fetched = false
    var query_batch
    let scrolling = this.fetch.fields[0].values
    for (var i in scrolling) {
      var checking = scrolling[i]
      if (checking.name == this.model.Lotto_materie_prime) {
        query_batch = checking.id
      }
    }

		axios.get(this.apiUrl + 'batchraws/' + query_batch, this.config)
      .then(response => {
      // JSON responses are automatically parsed.
        let deliveries_values = response.data.deliveries
      // eslint-disable-next-line
      // console.log(deliveries_values)
        this.deliveries = deliveries_values
      })
    axios.get(this.apiUrl + 'carriers/', this.config)
      .then(response => {
      // JSON responses are automatically parsed.
        let deliveries_carrier = response.data
        for (var i in deliveries_carrier) {
              var carrcheck = deliveries_carrier[i]
              for (var h in this.deliveries) {
                var delcheck = this.deliveries[h]
                // console.log(delcheck)
                // console.log("Checking between: " + carrcheck.id + " & " + delcheck.carrier)
                if (carrcheck.id == delcheck.carrier) {
                  // console.log("Found match between " + carrcheck.id + " & " +delcheck.carrier)
                  if (carrcheck.number !== null) {
                    this.deliveries[h].carriername = carrcheck.name + " - " + carrcheck.number
                  }
                  else{
                    this.deliveries[h].carriername = carrcheck.name
                  }
                    // eslint-disable-next-line
                    //console.log('Carrier add:', this.deliveries[h].carriername)
                  }
              }
        }
       this.fetched = true 
       this.loading = false  
      })
    },
    getrawmplist: function () {
    this.loading = true
    axios.get(this.apiUrl + 'batchraws?_sort=created_at:DESC', this.config)
      .then(response => {
    //  console.log(response.data)
      let rawmpbatch_values = []
      for (let r of response.data) {
      rawmpbatch_values.push(
        {"name": r.code,
        "id" : r.id
        }
      )
      }
      this.$store.commit('RAWMPLIST_FETCH', rawmpbatch_values)
      this.fetch.fields[0].values = rawmpbatch_values
      this.loading = false
      })
    },
      // JSON responses are automatically parsed.
  sendData: function () {
    this.loading = true 
    for (var i in this.analisi_temp) {
          var row = this.analisi_temp[i]
axios.put(this.apiUrl + 'deliveries/'+ row.id, 
    {
        "bacterial": row.bacterial,
        "fat": row.fat,
        "protein": row.protein,
        "ph": row.ph,
        "sourness": row.sourness,
        "stranger_milk": row.stranger_milk,
        "antibiotics": row.antibiotics,
        "mastitis": row.mastitis,
        "temperature": row.temperature
    }, this.config).then(() => {
      // eslint-disable-next-line
    this.msg_conferma = 'Informazioni registrate correttamente'
    this.schema.fields[0].disabled = true
    this.schema.fields[1].disabled = true
    this.sent = true
    }).catch((error) => { 
      // eslint-disable-next-line
      console.log(error)
      this.msg_conferma = 'Il lotto inserito esiste già, cambiare il nome'
      }).finally(() => {
      this.loading = false
    })
    }
  }
}
}
</script>

<style>
label > span ,.label{
  text-transform: uppercase;
  font-weight: 600
}
.lotto_materie_prime{
  padding-bottom: 1%;
  font-weight: bold;
  font-size:1.2rem;
}
</style>